import React from 'react';

const journeySteps = [
  { step: '01', title: 'Online intake', desc: 'Complete your medical questionnaire from home — takes about 15 minutes.' },
  { step: '02', title: 'Doctor review', desc: 'A BIG-registered physician reviews your case within 2 business days.' },
  { step: '03', title: 'Prescription & delivery', desc: 'Your medication is prescribed and shipped directly to your door.' },
  { step: '04', title: 'Ongoing support', desc: 'Monthly check-ins, dose adjustments, and a lifestyle coach if needed.' },
];

const trustBadges = [
  { label: 'BIG-registered doctors', icon: '🩺' },
  { label: 'GDPR/AVG compliant', icon: '🔒' },
  { label: 'NEN 7510 security', icon: '🛡️' },
  { label: 'Dutch pharmacy network', icon: '💊' },
];

export default function BrandPanel() {
  return (
    <div className="flex-1 bg-gradient-to-br from-[#0F6B5E] via-[#0d5e53] to-[#0a4a40] flex flex-col p-10 xl:p-14 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-80 h-80 rounded-full bg-white/5 -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-20 left-0 w-64 h-64 rounded-full bg-white/5 translate-y-1/2 -translate-x-1/2" />
      <div className="absolute top-1/2 right-8 w-32 h-32 rounded-full bg-[#4ABFA3]/20" />
      {/* Logo */}
      <div className="relative z-10 flex items-center gap-3 mb-12">
        <div className="w-11 h-11 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center border border-white/30">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 3C8 3 5 6.5 5 10.5C5 15 8.5 19 12 21C15.5 19 19 15 19 10.5C19 6.5 16 3 12 3Z" fill="white" opacity="0.9"/>
            <circle cx="12" cy="10.5" r="3.5" fill="white"/>
          </svg>
        </div>
        <div>
          <span className="font-bold text-2xl text-white tracking-tight">Waell</span>
          <span className="block text-xs text-white/60 font-medium tracking-wide">Medische gewichtsbehandeling</span>
        </div>
      </div>
      {/* Hero headline */}
      <div className="relative z-10 mb-10">
        <h1 className="text-3xl xl:text-4xl font-bold text-white leading-tight mb-3">
          Safe, medical obesity care — <span className="text-[#7DD6C4]">completely online</span>
        </h1>
        <p className="text-white/70 text-base leading-relaxed max-w-sm">
          GLP-1/GIP treatment supervised by Dutch doctors. From intake to delivery, without leaving home.
        </p>
      </div>
      {/* Journey steps */}
      <div className="relative z-10 space-y-4 mb-10">
        {journeySteps?.map((s) => (
          <div key={`step-${s?.step}`} className="flex items-start gap-4">
            <div className="w-8 h-8 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="font-mono text-xs font-semibold text-[#7DD6C4]">{s?.step}</span>
            </div>
            <div>
              <p className="font-semibold text-white text-sm">{s?.title}</p>
              <p className="text-white/60 text-xs leading-relaxed mt-0.5">{s?.desc}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Trust badges */}
      <div className="relative z-10 flex flex-wrap gap-2 mb-10">
        {trustBadges?.map((b) => (
          <span key={`badge-${b?.label}`} className="inline-flex items-center gap-1.5 bg-white/10 border border-white/20 rounded-full px-3 py-1.5 text-xs text-white/80 font-medium">
            <span>{b?.icon}</span>
            {b?.label}
          </span>
        ))}
      </div>
      {/* Testimonial */}
      <div className="relative z-10 mt-auto bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#4ABFA3] to-[#0F6B5E] flex items-center justify-center flex-shrink-0 text-white font-bold text-sm">
            MV
          </div>
          <div>
            <p className="text-white/90 text-sm leading-relaxed italic mb-2">
              &ldquo;Na jaren worstelen met mijn gewicht heb ik eindelijk een behandeling gevonden die werkt. Het Waell team is betrokken en professioneel.&rdquo;
            </p>
            <p className="text-white/60 text-xs font-medium">Marieke V., 44 — Amsterdam</p>
            <div className="flex items-center gap-0.5 mt-1">
              {[1, 2, 3, 4, 5]?.map((i) => (
                <svg key={`star-${i}`} width="12" height="12" viewBox="0 0 12 12" fill="#F59E0B">
                  <path d="M6 1l1.4 2.8L10.5 4l-2.3 2.2.5 3.2L6 8l-2.7 1.4.5-3.2L1.5 4l3.1-.2L6 1z"/>
                </svg>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Bottom legal */}
      <div className="relative z-10 mt-6 text-white/40 text-xs">
        © 2026 Waell B.V. · <a href="#" className="hover:text-white/60 transition-colors">Privacy</a> · <a href="#" className="hover:text-white/60 transition-colors">Terms</a> · KvK 12345678
      </div>
    </div>
  );
}